function toKey(v) {
  return String(v || "").trim().toLowerCase();
}

const STORAGE_KEY = "companyDisabledPermissionKeys";

const DEFAULT_DISABLED_BY_COMPANY = {
};

export function getCompanyDisabledPermissionKeys(companyKey) {
  const key = toKey(companyKey);
  const defaults = DEFAULT_DISABLED_BY_COMPANY[key] || [];

  // Future: allow Settings (master-only) to persist overrides.
  if (typeof window === "undefined") return defaults;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaults;
    const parsed = JSON.parse(raw);
    const arr = parsed && parsed[key];
    if (!Array.isArray(arr)) return defaults;
    return arr.map(toKey).filter(Boolean);
  } catch {
    return defaults;
  }
}

export function isPermissionKeyDisabledForCompany(companyKey, permissionKey) {
  const key = toKey(permissionKey);
  if (!key) return false;
  const disabled = getCompanyDisabledPermissionKeys(companyKey);
  return disabled.includes(key);
}

// Export the storage key so Settings can manage it later.
export const COMPANY_DISABLED_PERMISSION_KEYS_STORAGE_KEY = STORAGE_KEY;
